import {addQueryToPath} from '../../../../../../libs/shared/core/src/helpers/browser/urlHelpers';
import {ApiKnowledgeBaseCategory} from '../../../../../../libs/shared/core/src/models/api/knowledgeBaseCategoryModel';
import {KnowledgeBaseSupportedLanguagesTypesEnum} from '../../../../../../libs/shared/core/src/models/api/knowledgeBaseModel';
import {fetchApiAsync} from '../../../../../../libs/shared/core/src/services/http/http';
import {buildAppQueries} from '../../../../../../libs/shared/core/src/services/query/appQueryHelpers';

/*
 * Query.
 */

export const knowledgeBaseReportCategoryQueries = buildAppQueries('knowledgeBaseReportCategory ', {
  byId: (id: number, locale?: KnowledgeBaseSupportedLanguagesTypesEnum) => ({
    queryKey: {id},
    queryFn: async ({company, cancelToken}) => {
      // If the id is not greater than 0 we are not trying to fetch a valid category page.
      // This would be if we are trying to fetch the home or search pages.
      if (id <= 0) {
        return null;
      }
      return fetchApiAsync(
        ApiKnowledgeBaseCategory,
        addQueryToPath(`${company.url}/categories/${encodeURIComponent(id)}`, {locale}),
        {
          cancelToken,
        },
      );
    },
  }),
});
